module.exports = __webpack_public_path__ + "img/sims-4.45d2087e.png";